/* @flow */
import * as React from 'react';

const Map = props => (
  <svg
    width={84}
    height={91}
    viewBox="0 0 84 91"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="2.233 80.465 2.15 86.215 28.725 79.712 54.975 89.154 81.554 79.712 81.637 73.962 76.642 71.848 28.115 70.777"
    />
    <polygon points="2.233 80.465 2.15 86.215 28.725 79.712 54.975 89.154 81.554 79.712 81.637 73.962 76.642 71.848 28.115 70.777" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="72.788 12.598 50.691 21.026 29.936 11.585 8.854 18.087 2.233 80.466 28.809 73.963 55.058 83.404 81.638 73.963"
    />
    <path stroke="#DEDEDE" d="M50.691,21.027 L55.059,83.404" />
    <path stroke="#DEDEDE" d="M29.248,11.585 L29.247,73.962" />
    <polyline points="4.101 62.261 2.233 80.465 28.809 73.962 55.058 83.404 81.637 73.962 74.368 23.556" />
    <polyline points="53.943 19.786 50.691 21.026 29.936 11.585 8.854 18.088 7.167 33.982" />
    <path
      stroke="#677BC5"
      d="M17.255,66.433 L29.248,63.335 L54.36,73.092 L64.998,68.906 C68.261,67.622 70.222,64.272 69.743,60.798 L66.027,35.944"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M74.993,10.466 C74.993,5.514 70.979,1.5 66.027,1.5 C61.076,1.5 57.062,5.514 57.062,10.466 C57.062,15.418 61.076,19.432 66.027,19.432 C70.979,19.432 74.993,15.418 74.993,10.466"
    />
    <path d="M74.993,10.466 C74.993,5.514 70.979,1.5 66.027,1.5 C61.076,1.5 57.062,5.514 57.062,10.466 C57.062,15.418 61.076,19.432 66.027,19.432 C70.979,19.432 74.993,15.418 74.993,10.466 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M20.318,48.564 C20.318,43.368 16.106,39.155 10.909,39.155 C5.713,39.155 1.5,43.368 1.5,48.564 C1.5,53.76 5.713,57.973 10.909,57.973 C16.106,57.973 20.318,53.76 20.318,48.564"
    />
    <path d="M20.318,48.564 C20.318,43.368 16.106,39.155 10.909,39.155 C5.713,39.155 1.5,43.368 1.5,48.564 C1.5,53.76 5.713,57.973 10.909,57.973 C16.106,57.973 20.318,53.76 20.318,48.564 Z" />
    <path d="M66.027,20.709 L66.027,29.91" />
    <path d="M10.909,57.973 L10.909,67.384" />
  </svg>
);

export default Map;



// WEBPACK FOOTER //
// ./src/assets/images/icons/map.js